var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 223.6 223.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39b54a;}.cls-2{fill:#fefefe;}.cls-3{fill:#050505;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.52,0A111.94,111.94,0,1,0,223.6,111.79,111.86,111.86,0,0,0,111.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.46,111.78q0-22.92,0-45.84c0-10.71,6.45-17.14,17.17-17.15,19,0,38.09,0,57.14,0a6.52,6.52,0,0,1,5.21,2.2q8.49,8.88,17.21,17.55a6.76,6.76,0,0,1,2.08,5.31c-.1,6.31,0,12.63-.08,18.94,0,1.94.65,2.63,2.46,3.13,12,3.27,19.67,13,19.73,24.8.05,12-7.58,21.84-19.68,25.21-1.86.52-2.46,1.29-2.37,3.18.15,3.31.1,6.64,0,10-.22,9.39-6.89,16-16.29,16.08q-33.23.09-66.44,0c-9.55,0-16.14-6.79-16.17-16.46C63.43,143,63.46,127.4,63.46,111.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.47,120.88a21.73,21.73,0,1,1-21.58-21.79A21.64,21.64,0,0,1,180.47,120.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,56.64l12.89,12.54a49.4,49.4,0,0,1-10.17,0c-1.91-.15-2.76-1.57-2.73-3.5C141.9,62.74,141.87,59.77,141.87,56.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.71,73.43c-3.2.14-6.42,0-9.62-.16-4.53-.24-7.11-3-7.2-7.44-.06-3.21-.19-6.43.05-9.62.21-2.72-.56-3.53-3.4-3.5-17.93.14-35.86.06-53.79.07C72,52.78,67.38,57.35,67.37,66q0,22.92,0,45.83c0,15.61,0,31.22,0,46.82,0,7.41,4.9,12.35,12.25,12.36q33.21.08,66.41,0c7.09,0,11.85-4.65,12.17-11.76.14-3.09-.07-6.2.07-9.29.11-2.3-.16-3.82-3.09-3.66a13,13,0,0,1-4.5-1c-11.41-3.69-18.39-14.33-17.55-26.67.79-11.55,9.78-21.13,22.09-23,2.72-.42,3.12-1.43,3.06-3.74-.13-5-.2-10,0-14.94C158.45,74.09,157.37,73.32,154.71,73.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104,69.61c-7.86,0-15.72,0-23.58,0-1.47,0-3.53.4-3.58-1.85-.06-2.45,2.09-2.13,3.7-2.13q23.75,0,47.49,0c.44,0,.89,0,1.33,0,1.33.09,2.52.53,2.49,2.07s-1.3,1.89-2.61,1.9c-4.31,0-8.63,0-12.95,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.63,156.22c-7.3,0-14.6,0-21.9,0a12.22,12.22,0,0,1-2.64-.18,1.84,1.84,0,0,1-1.55-1.89,1.76,1.76,0,0,1,1.62-1.8,17.79,17.79,0,0,1,2.31-.13h44.81a18.62,18.62,0,0,1,2,.08,1.85,1.85,0,0,1,1.85,2c0,1.2-.85,1.76-1.92,1.91a19.51,19.51,0,0,1-2.65.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76,84.35c0-6.87-1-6.79,6.82-6.8,7.55,0,6.54.08,6.55,6.75,0,6.83.93,6.81-6.83,6.82S76.06,91,76,84.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.69,149c7.49,0,6.64-.74,6.69,6.82,0,7.11.41,6.57-6.71,6.56S76,163,76,155.86C76,148.31,75.25,149.07,82.69,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76,120c0-7.15-.68-6.72,6.89-6.71,6.49,0,6.5,0,6.48,6.43,0,7.46.91,7-6.89,7C75.07,126.76,76.06,127,76,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.44,86.74H98.52c-1.49,0-3.13,0-3-2,.08-1.69,1.52-1.94,2.94-1.94H126.9c1.43,0,2.85.3,2.88,2,0,2-1.62,2-3.1,2Q119.56,86.76,112.44,86.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.44,121.44c-4.2,0-8.4,0-12.6,0-1.43,0-3.21.14-3.27-1.86s1.56-2.15,3.09-2.15h26.2c1.4,0,2.88.23,2.94,2,.06,2-1.63,2-3.09,2C120.29,121.45,115.86,121.44,111.44,121.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.85,83c1.11.17,1.84.71,1.84,1.92a1.7,1.7,0,0,1-1.78,1.93,1.77,1.77,0,0,1-2-2A1.88,1.88,0,0,1,136.85,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.49,124.67c-.42-4.16.9-6.92,3.92-9,2.14-1.51,2.5-3.71.73-5.73s-3.87-2-5.78-.14c-1.08,1.08-2.08,2.31-3.51.73s0-2.68.93-3.67a7.92,7.92,0,0,1,11.51.44,7.53,7.53,0,0,1-1.11,11.35,6.11,6.11,0,0,0-2.84,5.53c0,1.69.86,4.38-2,4.38S156.8,125.74,156.49,124.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.07,135.87c-1.5,0-2.19-.73-2.24-1.79a1.82,1.82,0,0,1,2-2.06,1.75,1.75,0,0,1,1.75,2A1.73,1.73,0,0,1,159.07,135.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.33,102.16c.53,2.3-.65,2.67-2.68,2.72-2.24.06-2.69-.8-2.73-2.85,0-2.22.77-2.7,2.84-2.74C85,99.26,85.77,100,85.33,102.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.42,87.08c-2.67.51-2.33-1.3-2.49-3-.24-2.54,1.25-2.42,3-2.57,2.68-.23,2.3,1.43,2.47,3.11C85.69,87.12,84.32,87.35,82.42,87.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.88,135.23c2.48-.61,2.44.92,2.57,2.77.18,2.4-1,2.52-2.89,2.63-2.4.14-2.54-1-2.63-2.92C79.81,135.34,80.85,134.84,82.88,135.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.61,153.09c2.14-.46,2.89.34,2.85,2.57,0,2-.39,2.93-2.68,2.84-2-.07-3-.38-2.86-2.68C80,153.84,80.25,152.55,82.61,153.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.33,119.93c.45,2.16-.37,2.9-2.61,2.9s-2.8-.69-2.8-2.84.52-2.87,2.76-2.83S85.85,117.68,85.33,119.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.6f6acca6fff4a2cfc3e66a0f3cc13fbe.svg";
export { ForwardRef as ReactComponent };